import React from 'react';
import { cn } from '@bem-react/classname';
import { YAText } from '@ui-kit';
import 'react-gallery-carousel/dist/index.css';
import { useNavigate } from 'react-router-dom';
import './Header.styles.scss';
import { menu_list } from '@config/menu-config';

const CnHeader = cn('header');

const Header = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={CnHeader()}>
        <div className={CnHeader('logo')}>
          <YAText text={'YA'} type={'H1'} onClick={() => navigate('/')} />
        </div>
        <div className={CnHeader('menu')}>
          {menu_list.map((item, index) => (
            <div key={index} className={CnHeader('menu-item')}>
              <YAText text={item.text} type={'text'} onClick={() => navigate(item.path)} />
            </div>
          ))}
        </div>
      </div>
      <div className={CnHeader('height')} />
    </>
  );
};

export default Header;
